import { useQuery } from "@tanstack/react-query";
import { useKeycloak } from "@react-keycloak/web";
import { myDetailsQuery } from "./usersApi";

// The signed-in user's profile for components, from the same shared copy
// getMyDetails reads (see usersApi). undefined until it has loaded.
export const useMyDetails = () => {
    const { keycloak } = useKeycloak();
    const token = keycloak.token;
    const query = useQuery({
        ...myDetailsQuery(token as string),
        enabled: !!token && !keycloak.isTokenExpired(),
    });
    return query.data ?? undefined;
};
